import {combine} from 'effector';

import {loadGridCsv} from 'api';
import {fetchGtinsGrid} from 'api/registries';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {SimplePaginationContent} from 'types/api';
import {GtinsGridRawRow} from 'types/gtins';

const domain = rootDomain.createDomain('GtinsGridTableDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchGtinsGrid,
});

export const fetchCsv = domain.createEffect({
    name: 'fetchRegistriesCsv',
    handler: loadGridCsv,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    Gate,
    tableStateChanged,
    tableStateCacheChanged,
    stateReset,
} = createGridTableModel({domain});

export const data$ = domain.createStore<SimplePaginationContent<GtinsGridRawRow> | null>(null);

export const tableState$ = combine({
    data: data$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
    isLoading: fetchDataFx.pending,
    exportPending: fetchCsv.pending,
});
